import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import Inicio from '@/components/inicio'
import Lista from '@/components/lista'
import Ajustes from '@/components/ajustes'


Vue.use(Router)

export default new Router({
  routes: [
    {
      name: 'Inicio',
      path: '/',
      component: Inicio
    },
    {
      name: 'Lista',
      path: '/carregar-lista',
      component: Lista
    },
    {
      name: 'Ajustes',
      path: '/ajustes',
      component: Ajustes
    },
      
  ],
   mode: 'history',
})



// WEBPACK FOOTER //
// ./src/router/index.js